export default __webpack_public_path__ + "static/media/background.42a45deb.webp";